import React, { useState } from "react";
import Auth from "../auth/Auth/Auth";
import styles from "./FollowButton.module.scss";

const FollowButton = ({ isFollowing, user, followChannel, channelID }) => {

  return (
    <>
      {!user?.access ? (
        <button
          className={styles.followButton}
          onClick={() => followChannel(channelID, null, "follow")}
        >
          Follow
        </button>
      ) : !isFollowing ? (
        <button
          className={styles.followButton}
          onClick={() => followChannel(channelID, user?.access, "follow")}
        >
          Follow
        </button>
      ) : (
        <button
          className={styles.followButton}
          onClick={() => followChannel(channelID, user?.access, "unfollow")}
        >
          Unfollow
        </button>
      )}
    </>
  );
};

export default FollowButton;
